import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import TextField from "@mui/material/TextField";
import { useState } from "react";
import { BUTTON_SX } from "../../../../../lib/constants.js";
import { formatString } from "../../../../../lib/formatString.js";

export default function AssignToHostDialog({
  character,
  hosts,
  locales,
  onAssign,
  onClose,
  show,
}) {
  const [selectedHost, setSelectedHost] = useState(null);

  return (
    <Dialog open={show}>
      <DialogContent>
        <DialogContentText color="text.primary">
          {formatString(locales["character.assign.text"], [character.name])}
        </DialogContentText>
        <Autocomplete
          getOptionDisabled={(option) => option.id === character.host?.id}
          getOptionLabel={(option) => option.serial}
          onChange={(event, value) => setSelectedHost(value)}
          options={hosts || []}
          renderInput={(params) => (
            <TextField
              {...params}
              label={locales["character.assign.label"]}
              margin="dense"
              sx={{
                "& .MuiFilledInput-root": {
                  backgroundColor: "backgroundContrast.main",
                },
                "& .MuiInputBase": {
                  backgroundColor: "backgroundContrast.main",
                },
                "& .MuiAutocomplete-clearIndicator": {
                  color: "secondary.main",
                },
                "& .MuiAutocomplete-popupIndicator": {
                  color: "secondary.main",
                },
              }}
              variant="filled"
            />
          )}
          value={selectedHost}
        />
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-around" }}>
        <Button
          onClick={() => onAssign(selectedHost)}
          color="secondary"
          disabled={!selectedHost}
          size="large"
          sx={BUTTON_SX.DISABLED}
        >
          {locales["character.assign.button.assign"]}
        </Button>
        <Button onClick={onClose} color="primary" size="large">
          {locales["character.assign.button.cancel"]}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
